import Main from "./top/main.es6";

const main = new Main();